import axios from 'axios';
const QUIZLER_URL = process.env.QUIZLER_URL || '/api/quizler';

export const fetchAssessment = (assessmentName, versionId) => {
    return axios({
        method: 'GET',
        url: `${QUIZLER_URL}/assessment-profile/${assessmentName}/${versionId}`
    })
};